module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "md-button md-raised md-primary md-button-color md-theme-default heght-1px",
    on: {
      "click": _vm.previousClientView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateUser($event)
      }
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('h2', [_vm._v("View Contract")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Validity From Date:")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Validity To Date:")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Select Contract Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "contractType",
      "id": "contractType",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.contractType),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "contractType", $$v)
      },
      expression: "contractDetailModal.contractType"
    }
  }, [_c('md-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "fuelType"
    }
  }, [_vm._v("Fuel Type")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "freeKMType"
    }
  }, [_vm._v("Free KM TYPE")])], 1)], 1), _vm._v(" "), (!_vm.contractDetailModal.contractType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isContractError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "-2%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.contractDetailModal.fromValidity),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "fromValidity", $$v)
      },
      expression: "contractDetailModal.fromValidity"
    }
  }), _vm._v(" "), (!_vm.contractDetailModal.fromValidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isFromValidtyError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.contractDetailModal.toValidity),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "toValidity", $$v)
      },
      expression: "contractDetailModal.toValidity"
    }
  }), _vm._v(" "), (!_vm.contractDetailModal.toValidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isToValidtyError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Monthly fixed rental for each dedicated vehicle")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "monthlyRent",
      "name": "monthlyRent",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.monthlyRent),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "monthlyRent", $$v)
      },
      expression: "contractDetailModal.monthlyRent"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.monthlyRent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isMonthlyRentError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Number of dedicated vehicles")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "noOfTrucks",
      "name": "noOfTrucks",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.noOfTrucks),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "noOfTrucks", $$v)
      },
      expression: "contractDetailModal.noOfTrucks"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.noOfTrucks) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noOfTrucksError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.contractDetailModal.contractType == 'freeKMType') ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Kilometer per vehicle per months")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "allowedKm",
      "name": "allowedKm",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.allowedKm),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "allowedKm", $$v)
      },
      expression: "contractDetailModal.allowedKm"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.allowedKm) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isAllowedKmError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vehicle Modal")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleModal",
      "name": "vehicleModal",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.vehicleModal),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "vehicleModal", $$v)
      },
      expression: "contractDetailModal.vehicleModal"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.vehicleModal) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleModalError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "vehicleType",
      "id": "vehicleType"
    },
    model: {
      value: (_vm.contractDetailModal.vehicleType),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "vehicleType", $$v)
      },
      expression: "contractDetailModal.vehicleType"
    }
  }, [_c('md-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _vm._l((_vm.vehicleTypeMaster), function(item, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": item.vehicleTypeId
      }
    }, [_vm._v(_vm._s(item.vehicleType))])
  })], 2)], 1), _vm._v(" "), (!_vm.contractDetailModal.vehicleType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "grossWeight", $$v)
      },
      expression: "contractDetailModal.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.grossWeightError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.contractDetailModal.contractType == 'freeKMType') ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Additional charges over allowed Km")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "overcharges",
      "name": "overcharges",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.overcharges),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "overcharges", $$v)
      },
      expression: "contractDetailModal.overcharges"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.overcharges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isOverChargesError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color",
    attrs: {
      "disabled": _vm.permissionStatus,
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addContract
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog2",
    staticClass: "HereDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  })])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary"
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a48e712","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/clients/viewHireContract.vue
// module id = 2763
// module chunks = 0